<template>
  <div class="m-2">
    <b-row>
      <b-col>
        <button
          class="btn waves-effect waves-light d-block mx-auto"
          :class="frontDevMode ? 'btn-danger' : 'btn-outline-info'"
          type="button"
          @click="showConfirm = true"
        >
          {{ frontDevMode ? "Вимкнути" : "Увімкнути" }} DevMode
        </button>
      </b-col>
    </b-row>

    <dialog-modal
      v-if="showConfirm"
      classhead="bg-warning"
      @close="showConfirm = false"
    >
      <template v-slot:title>
        {{ frontDevMode ? "Вимкнути" : "Увімкнути" }} DevMode
      </template>
      <template v-slot:body>
        <div class="d-flex align-items-start gap-3">
          <i class="ri-alert-line fs-2 text-warning mt-1"></i>
          <div>
            <p class="mb-1 fw-semibold">Ви впевнені?</p>
            <p class="mb-0 text-muted">
              {{
                frontDevMode
                  ? "DevMode буде вимкнено для цієї компанії."
                  : "DevMode буде увімкнено для цієї компанії. Функція призначена виключно для внутрішнього використання!"
              }}
            </p>
          </div>
        </div>
      </template>
      <template v-slot:footer-bottom>
        <button class="btn btn-light" @click="showConfirm = false">
          Скасувати
        </button>
        <button
          class="btn"
          :class="frontDevMode ? 'btn-danger' : 'btn-warning'"
          @click="confirmToggle"
        >
          {{ frontDevMode ? "Вимкнути" : "Увімкнути" }}
        </button>
      </template>
    </dialog-modal>
  </div>
</template>

<script>
import { SuperAdmin } from "@/API.js";
import dialogModal from "@/components/modal/dialog.vue";

let apiServe = new SuperAdmin();

export default {
  components: { dialogModal },
  props: ["companyId", "devMode"],
  data() {
    return {
      frontDevMode: false,
      showConfirm: false,
    };
  },
  created() {
    if (this.devMode) {
      this.frontDevMode = this.devMode;
    }
  },
  methods: {
    confirmToggle() {
      this.showConfirm = false;
      const newValue = !this.frontDevMode;

      apiServe.setFrontDevMode(this.companyId, newValue).then((result) => {
        if (result.status === "done") {
          this.frontDevMode = result.data.frontDevMode;
          this.$toast.success(
            `Dev Mode: ${this.frontDevMode ? "увімкнено" : "вимкнено"}`,
          );
        } else {
          this.$toast.error(this.$t("error"));
        }
      });
    },
  },
};
</script>

<style></style>
